import { useMutation } from 'react-query'
import axios from 'axios'
import { SendContractEmailRequest, SendContractEmailResponse } from 'BrokerTsLib/src/dtos'

const carkulkaUrl = process.env.REACT_APP_CARKULKA_URL

export const useCancelContract = () =>
  useMutation({
    mutationFn: (insuranceId: number) =>
      axios.post<{
        bStornovano?: boolean
        bCmdStorno1?: boolean
        bCmdStorno2?: boolean
        stornoMsg1?: string
        stornoMsg2?: string
        stornoMsg11?: string
      }>(`${carkulkaUrl}/InsuranceWizard/CancelContract?insuranceId=${insuranceId}`, undefined, {
        withCredentials: true,
      }),
  })



export const useSaveVehicleAdditionalInfo = () =>
  useMutation({
    mutationFn: ({
      paramsId,
      licencePlate,
      technicalCertificateNumber,
      registrationCertificateNumber
    }: {
      paramsId: string
      licencePlate?: string | null
      technicalCertificateNumber?: string | null
      registrationCertificateNumber?: string | null
    }) =>
      axios.get<{ status: 0 | 1 | 2; text: string }>(
        `${carkulkaUrl}/InsuranceWizard/SaveVehicleAdditionalInfoInternal?paramsId=${paramsId}&licencePlate=${licencePlate}&technicalCertificateNumber=${technicalCertificateNumber}&registrationCertificateNumber=${registrationCertificateNumber}`,
        { withCredentials: true },
      ),
  })

export const useSendContractEmail = () =>
  useMutation((request: SendContractEmailRequest) =>
    axios.post(`${carkulkaUrl}/Mailing/SendContractEmailIntern?id=${request.id}&insuranceId=${request.insuranceId}`, undefined, { withCredentials: true, }))

export const sendCsobDiscountEmail = (paramsId: string) =>
  axios.get<SendContractEmailResponse>(
    `${carkulkaUrl}/Mailing/SendCsobDiscountNotificationMail?paramsId=${paramsId}`,
    {
      withCredentials: true,
    },
  )

export const useFreeCancelation = () =>
  useMutation({
    mutationFn: (paramsId: string) =>
      axios.get(`${carkulkaUrl}/InsuranceWizard/FreeCancelation?id=${paramsId}`, {
        withCredentials: true,
      }),
  })

export const useSendStatisticEmail = () =>
  useMutation((url: string) =>
    axios.get(url, { withCredentials: true }))
